import { h } from 'preact'

import ImpactIcon     from './ImpactIcon'
import CountUpWrapper from './CountUpWrapper'

import setBrandColor  from '../setBrandColor'
import assetUrl       from 'src/utils/assetUrl'
import moneyFormat    from 'src/utils/moneyFormat'

/** @jsx h */

const logo = assetUrl(RAILS_ASSET_URL('/logo.svg'))
const logoWhite = assetUrl(RAILS_ASSET_URL('/logo-white.svg'))

const ImpactContent = props => {
  const impactWidgetBg = {
    brand_color_in_background: 'bg-primary',
    brand_color_in_foreground: 'bg-white',
  }[props.widget_style]

  const impactWidgetFg = {
    brand_color_in_background: 'text-default',
    brand_color_in_foreground: 'text-primary',
  }[props.widget_style]

  const logoSrc = {
    brand_color_in_background: logoWhite,
    brand_color_in_foreground: logo,
  }[props.widget_style]

  const widgetClassName = [
    props.showInfo  && 'widget-show-info',
    props.flipping  && 'widget-flip',
    props.halfway   && 'widget-show-info-halfway',
  ].filter(Boolean).join(' ')

  document.body.classList.remove('bg-primary', 'bg-white')
  document.body.classList.add(impactWidgetBg)

  setBrandColor(props.brand_color)

  return (
    <div className={`widget ${widgetClassName}`}>
      <div className="widget-content">
        <div className="widget-content-inner">
          <div className={`widget-face ${impactWidgetBg}`}>
            <div className={`widget-icon ${impactWidgetFg}`}>
              <ImpactIcon icon={props.icon} />
            </div>

            <div className={`widget-counter ${impactWidgetFg}`}>
              <h1 className="h3 widget-title">
                <CountUpWrapper
                  {...moneyFormat(props.money_format, props.currency_symbol)}
                  amount={props.amount}
                />
              </h1>
            </div>

            <div className="widget-description">
              <p>{props.description}</p>
            </div>

            <a href="https://www.pledge.to/" target="_blank"
              className="widget-link widget-link-pledgeling">
              <img src={logoSrc} alt="Pledge" />
            </a>

            <a
              href="#info"
              className="widget-link widget-link-info"
              onClick={props.openInfo}
              style={{ display: props.info == '<p></p>' ? 'none' : 'block' }}
            >
              <span aria-hidden="true">i</span>
              <span className="sr-only">info</span>
            </a>
          </div>

          <div className="widget-info bg-white">
            <a
              href="#close"
              className="widget-link widget-link-close"
              onClick={props.closeInfo}
            >
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">close</span>
            </a>

            <div className="widget-info-inner">
              <div className="widget-info-content"
                dangerouslySetInnerHTML={{ __html: props.info }}>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImpactContent
